import qs from 'qs';

export const stringifyQueryParams = (obj: any) => {
  return qs.stringify(obj, {
    arrayFormat: 'brackets',
    encodeValuesOnly: true,
  });
};
